import { cn } from '@/lib/utils';
import { formatStrategyType } from '@/lib/formatters';
import type { StrategyType } from '@steward/shared';

export interface StrategyBadgeProps {
  strategy: StrategyType;
  size?: 'sm' | 'md';
  className?: string;
}

const strategyColors: Record<StrategyType, string> = {
  single_call: 'bg-blue-100 text-blue-700',
  single_put: 'bg-purple-100 text-purple-700',
  covered_call: 'bg-green-100 text-green-700',
  cash_secured_put: 'bg-emerald-100 text-emerald-700',
  vertical_spread: 'bg-amber-100 text-amber-700',
  iron_condor: 'bg-orange-100 text-orange-700',
  iron_butterfly: 'bg-rose-100 text-rose-700',
  straddle: 'bg-cyan-100 text-cyan-700',
  strangle: 'bg-teal-100 text-teal-700',
  calendar_spread: 'bg-indigo-100 text-indigo-700',
  diagonal_spread: 'bg-violet-100 text-violet-700',
  custom: 'bg-gray-100 text-gray-700',
};

export function StrategyBadge({ strategy, size = 'md', className }: StrategyBadgeProps) {
  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-xs',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center font-medium rounded-full',
        strategyColors[strategy] || 'bg-gray-100 text-gray-700',
        sizes[size],
        className
      )}
    >
      {formatStrategyType(strategy)}
    </span>
  );
}
